import { render, staticRenderFns } from "./ShortVideoInfo.vue?vue&type=template&id=099d5eac&scoped=true"
import script from "./ShortVideoInfo.vue?vue&type=script&lang=js"
export * from "./ShortVideoInfo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoInfo.vue?vue&type=style&index=0&id=099d5eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099d5eac",
  null
  
)

export default component.exports